import React, { FC, ReactNode } from 'react'
import { Cross, ChevronLeft } from '@components/icons'
import cn from 'clsx'
import { Button } from '@components/ui'
import usePrice from '@framework/product/use-price'
import { useUI } from '@components/ui/context'
import dataLayer from '@utils/dataLayer'

const ns = `cart-sidebar-layout`

type ComponentProps = {
  className?: string
  data?: any
  children?: ReactNode
  cartPromo?: string
} & (
  | { handleClose: () => any; handleBack?: never }
  | { handleBack: () => any; handleClose?: never }
)

const CartSidebarLayout: FC<ComponentProps> = ({
  children,
  className,
  handleBack,
  handleClose,
  data,
  cartPromo,
}) => {
  const rootClassnames = cn({
    [`${ns}`]: true,
    [`${ns}--auto-height`]: data?.lineItems?.length > 3,
    [`${className}`]: className,
    [`sidecart`]: true,
  })

  // const router = Router
  const { setSidebarView } = useUI()

  const { price: total } = usePrice(
    data && {
      amount: Number(data.totalPrice),
      currencyCode: data.currency.code,
    }
  )

  const goToCheckout = (url: string) => {
    // Add event to data layer
    dataLayer().push(
      `begin_checkout`,
      data?.lineItems.map((item: any) => {
        return {
          product: item,
          variant: {
            ...item?.variant,
          },
          quantity: item?.quantity,
        }
      })
    )

    window.location.href = url
    // router.push(url)
  }

  return (
    <div className={rootClassnames}>
      <div className={`${ns}__promo`}>
        <h6>{cartPromo}</h6>
      </div>
      <header className={`${ns}__header`}>
        <h4>Your Cart</h4>
        {handleClose && (
          <button
            onClick={handleClose}
            aria-label="Close"
            className={`${ns}__icon`}
          >
            <Cross />
          </button>
        )}
        {handleBack && (
          <button
            onClick={handleBack}
            aria-label="Go back"
            className={`${ns}__button`}
          >
            <ChevronLeft />
            <span>Back</span>
          </button>
        )}
      </header>

      <div className={`${ns}__container`}>{children}</div>

      <div className={`${ns}__footer`}>
        <div className={`${ns}__total`}>
          <h5>
            Estimated Total{' '}
            {data?.lineItems?.length > 0 && `(${data?.lineItems.length} items)`}
          </h5>
          <h5>{total}</h5>
        </div>
        <div className={`${ns}__cta`}>
          {data?.lineItems?.length ? (
            process.env.COMMERCE_CUSTOMCHECKOUT_ENABLED ? (
              <Button Component="a" width="100%" href={data?.url || '#'}>
                Proceed to Checkout ({total})
              </Button>
            ) : (
              <Button
                onClick={() => goToCheckout(data?.url)}
                // href={(data && data.url) || '#'}
                width="100%"
              >
                Proceed to Checkout
              </Button>
            )
          ) : (
            <Button href={(data && data.url) || '#'} Component="a" width="100%">
              Shop Products
            </Button>
          )}
          <div className={`${ns}__cta-note`}>
            <p>Shipping and promotions calculated in checkout.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CartSidebarLayout
